export interface GapAnalysisImportIssue {
  id: string;
  source: string;
  reason: string;
  description: string;
}

export const GAP_ANALYSIS_IMPORT_ISSUES_TITLE = "Import issues";

export const GAP_ANALYSIS_IMPORT_ISSUES_SUBTITLE =
  "Fix these in D2L Brightspace, then re-sync to pull the corrected items in. Dismiss to clear without re-importing.";

export const GAP_ANALYSIS_IMPORT_ISSUES_RESYNC_SUCCESS_TITLE = "Re-sync complete";

export const GAP_ANALYSIS_IMPORT_ISSUES_RESYNC_SUCCESS_DESCRIPTION =
  "3 source documents are now available in your course. Content freshness has been updated to reflect the refreshed material.";

export const GAP_ANALYSIS_IMPORT_ISSUES_CONTENT: GapAnalysisImportIssue[] = [
  {
    id: "permission-denied",
    source: "Faculty_Lecture_Slides_Mod5.pptx",
    reason: "Permission denied",
    description: "File requires authentication to a faculty SharePoint folder - unable to access.",
  },
  {
    id: "broken-link",
    source: "https://www.metmuseum.org/collection/old-installation-link",
    reason: "Broken link",
    description: "Link returned 404 - museum installation page was removed.",
  },
  {
    id: "unsupported-format",
    source: "WebGL_Virtual_Gallery_Tour",
    reason: "Unsupported file format",
    description: "WebGL gallery tour cannot be analyzed - content type not supported by the modernizer.",
  },
];
